import React from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { toJSX } from 'src/utils/toJSXHelper';
import styles from './index.module.scss';

type Props = {
  title: string;
  imageSrc: string;
  regardingSales: string;
  howToConfirm: string;
  regardingSalesDesc: (className: string) => string;
  closeModal: () => void;
};

export const Presenter: React.FC<Props> = ({
  title,
  regardingSales,
  regardingSalesDesc,
  howToConfirm,
  imageSrc,
  closeModal,
}) => (
  <CommonModal
    title={title}
    closeModal={closeModal}
    fixedElement={
      <div className={styles.wrap}>
        <div className={styles.regardingSales}>{regardingSales}</div>
        <div className={styles.description}>
          <p>{toJSX(regardingSalesDesc(styles.strong))}</p>
        </div>
        <div>{howToConfirm}</div>
        <div className={styles.confirmWrap}>
          <NextImage src={imageSrc} width={229} height={263} alt={title} />
        </div>
      </div>
    }
  />
);
